import { Location, sendAppInstallStartEvent } from 'features/installPwa/analytics';
import { useTranslation } from 'react-i18next';
import { APP_STORE_BETFAN_LINK } from 'shared/constants/common';

interface AppStoreButtonProps {
	className?: string;
	location: Location;
}

export const AppStoreButton = ({ className, location }: AppStoreButtonProps) => {
	const { t } = useTranslation();
	return (
		<a
			href={APP_STORE_BETFAN_LINK}
			target="_blank"
			rel="noreferrer"
			onClick={() => sendAppInstallStartEvent(location)}
			className={`bg-[url(assets/images/appstore-download.svg)] relative block w-[120px] h-[40px] bg-no-repeat bg-contain z-1 ${className}`}
		>
			<span className="sr-only">{t('iosAppDownload')}</span>
		</a>
	);
};
